import { SubEventModel } from './subevent-model';
import { GuestModel } from './guest-model';
import { EventCodeModel } from './eventcode-model';


export class EventModel {

    constructor(readonly code: EventCodeModel,
                readonly subEvents: SubEventModel[],
                readonly title: string,
                readonly description: string,
                readonly teaser: string,
                readonly area: string,
                readonly organizer: string,
                readonly rsvpDate: Date){
    }

    public getStartDateTime() {
      //sort sub-events in start date ascending order, and return first one (that is: the first event)
      return this.subEvents.slice(0)
              .sort((leftSide, rightSide): number => {
                if(leftSide.startDateTime < rightSide.startDateTime) return -1;
                if(leftSide.startDateTime > rightSide.startDateTime) return 1;
                return 0;
              })[0].startDateTime;
    }

    public getEndDateTime() {
      //sort sub-events in end date descending order, and return first one (that is: the last event)
      return this.subEvents.slice(0)
              .sort((leftSide, rightSide): number => {
                if(leftSide.endDateTime > rightSide.endDateTime) return -1;
                if(leftSide.endDateTime < rightSide.endDateTime) return 1;
                return 0;
              })[0].endDateTime;
    }

    /*public getTotalGuestList(): GuestModel[] {
      let guests = [];
      this.subEvents.forEach(e => guests.push(...e.guests));
      return Arrays.from(new Set(guests));
    }*/

    public getSubEvents(guest: GuestModel): SubEventModel[]{
      let events = this.subEvents.filter(e => guest.isInvitedTo(e));
      return events;
    }

}


// WEBPACK FOOTER //
// ./src/app/models/event-model.ts